<template>
    <v-card >
        <v-card-text>
            <v-form
                ref="form">

                <v-text-field
                    :dense="false"
                    :label="$t('sales_order_number')"
                    hide-details
                    v-model="form.sales_order_code">
                </v-text-field>
                <customer-search
                    :dense="false"
                    :label="$t('customer')"
                    hide-details
                    item-value="id"
                    item-text="display_name"
                    v-model="form.customer_id">
                </customer-search>
                <user-search
                    :dense="false"
                    label="Created By"
                    hide-details
                    item-value="id"
                    item-text="name"
                    v-model="form.user_id">
                </user-search>
                <v-select
                    label="State"
                    v-model="form.state"
                    hide-details="auto"
                    :items="states"
                    clearable>
                </v-select>
                <v-menu
                    ref="menu_date_from"
                    v-model="menu.date_from"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_from"
                            :rules="rules.date_from"
                            :label="$t('date_from')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker v-model="form.date_from" @input="menu.date_from = false" no-title scrollable></v-date-picker>
                </v-menu>

                <v-menu
                    ref="menu_date_to"
                    v-model="menu.date_to"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form.date_to"
                            :rules="rules.date_to"
                            :label="$t('date_to')"
                            append-icon="mdi-calendar"
                            hide-details="auto"
                            readonly
                            v-bind="attrs"
                            v-on="on">
                        </v-text-field>
                    </template>
                    <v-date-picker :min="form.date_from" v-model="form.date_to" @input="menu.date_to = false" no-title scrollable></v-date-picker>
                </v-menu>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn
                text
                @click="submit"
                :loading="loading"
                :disabled="loading">
                {{ $t("search") }}
            </v-btn>
            <v-btn text @click="resetForm">
                {{ $t("reset") }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import CustomerSearch from '../searchComponents/CustomerSearch';
import UserSearch from '../searchComponents/UserSearch';

export default {
    name: "SalesOrderSearchMenu",
    components: {
        CustomerSearch,
        UserSearch
    },
    props: {
        loading: {
            required: false,
            type: Boolean
        },
        close: {
            required: false,
            type: Boolean
        }
    },
    data() {
        return {
            display: false,
            form: {
                sales_order_code: null,
                customer_id: null,
                user_id: null,
                date_from: null,
                date_to: null,
            },
            menu: {
                date_from: false,
                date_to: false
            },
            rules: {
                date_from: [

                ],
                date_to: [

                ]
            },
             states: [
                { text: "Open", value: "OPEN" },
                { text: "Closed", value: "CLOSED" },
            ],
        }
    },
    methods: {
        submit() {
            this.$emit("submit", this.form);
        },
        resetForm() {
            this.$refs.form.reset();
            this.form.user_id = null;
            this.form.customer_id = null;
        }
    },
    created() {

    }
}
</script>